export default "__VITE_ASSET__cKjpFmFU__"